import React from 'react';
import type { AiAssistantButtonParams } from '@sharefiledev/qna-pilet-sdk';
import { RID } from '@sharefiledev/sfplugin-resource-id';
import { Account, PiletApi } from '@sharefiledev/sharefile-appshell';
import { analyticsIds } from 'pendo';
import { LocalizationLoader } from 'utils/translate';
import { AssistantButtonComponent } from './AssistantButtonComponent';

export type AiAssistantButtonProps = AiAssistantButtonParams & {
	piletApi: PiletApi;
};

export const AiAssistantButton: React.FC<AiAssistantButtonProps> = props => {
	const { piletApi, zoneId, resourceRID, disable } = props;

	if (zoneId && !zoneId.startsWith('zp')) {
		return null;
	}

	const enableAIGeneratedContentQnAProperty = 'EnableAIGeneratedContentQnA';
	const account: Account = piletApi.sf.piletUserContext.get().account;
	if (
		!account.Preferences ||
		!(enableAIGeneratedContentQnAProperty in account.Preferences!) ||
		!!!account.Preferences?.EnableAIGeneratedContentQnA
	) {
		return null;
	}

	let parsedRID: string;

	try {
		parsedRID = RID.parse(resourceRID).toString();
	} catch {
		return null;
	}

	return !!disable ? null : (
		<LocalizationLoader loadingElement={null}>
			{() => (
				<span data-analytics-id={analyticsIds.aiAssistant.openAIAssistantButton}>
					<AssistantButtonComponent {...props} resourceRID={parsedRID} />
				</span>
			)}
		</LocalizationLoader>
	);
};
